<template>
  <section>
    <b-table
      :loading="isLoading"
      :striped="true"
      :hoverable="true"
      default-sort="score"
      default-sort-direction="desc"
      :data="rankingData"
      paginated
      backend-pagination
      :total="totalData"
      @page-change="page = $event"
      :current-page="page"
      :per-page="perPage"
    >
      <template slot-scope="props">
        <!-- <b-table-column label="" field="">
          <b-tooltip :label="props.row.old_rider == true ? 'Jinete antiguo' : 'Jinete Actual' " position="is-right">
            <b-icon icon="account-arrow-left" type="is-danger" v-if="props.row.old_rider"/>
            <b-icon  icon="account-check" type="is-success" v-else/>
          </b-tooltip>
        </b-table-column> -->
        <b-table-column label="#" field="id" centered>
          <h4 class="title is-3">{{ props.row.position}}</h4>
        </b-table-column>
        <b-table-column label="Jinete" field="name">
          <link-to-detail type="rider" :resource-id="props.row.rider_id"> {{`${props.row.rider_lastname} ${props.row.rider_name}`}} </link-to-detail>
        </b-table-column>
        <b-table-column label="Fre" field="frecuencia" centered>
          {{ props.row.frequency}}
        </b-table-column>
        <b-table-column label="Puntaje" field="score" centered>
          <score-tag :score="props.row.score"/>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Resultados...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay Resultados&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </section>
</template>

<script>
import ScoreTag from '@/components/ScoreTag.vue'
import LinkToDetail from '@/components/LinkToDetail'
import RankingService from '@/services/RankingService'

export default {
  components: {
    ScoreTag,
    LinkToDetail
  },
  created () {
    this.getRanking()
  },
  props: {
    lessonId: {
      required: false,
      type: Number,
      default: 0
    },
    fromDate: {
      required: false,
      type: Date,
      default: () => new Date().setMonth(new Date().getMonth() - 1)
    },
    toDate: {
      required: false,
      type: Date,
      default: () => new Date()
    }
  },
  data () {
    return {
      rankingPositions: [],
      rankingData: [],
      isLoading: false,
      totalData: 0,
      perPage: 100,
      page: 1,
      active: 1,
    }
  },
  methods: {
    async getRanking () {
      this.isLoading = true
      let response = await RankingService.getRankingRiders({
        'lessons[0]': this.lessonId === 0 ? null : this.lessonId,
        'from': this.$moment(this.fromDate).format('YYYY-MM-DD').toString(),
        'to': this.$moment(this.toDate).format('YYYY-MM-DD').toString(),
        'page': this.page,
        'per_page': this.perPage,
        'active': this.active
      })
      this.totalData = response.data.meta.total
      this.rankingData = response.data.data
      this.isLoading = false
    }
  },
  watch: {
    lessonId (value) {
      this.getRanking()
    },
    fromDate (value) {
      this.getRanking()
    },
    toDate (value) {
      this.getRanking()
    },
    page (value) {
      this.getRanking()
    },
    totalData (value) {
      this.$emit('number-result-changed', value)
    }
  }
}
</script>

<style scoped>
  .gender-male > *{
    color: #2196F3 !important;
  }

  .gender-female{
    color: #E91E63;
  }

</style>
